module.exports = __webpack_public_path__ + "static/media/banner_qrcode_site_vestibular2.669b1e4e.png";